module.exports = __webpack_public_path__ + "static/media/trinity-haircare-circles.6de147bb.png";